import { addWarehouse, allWarehouses, deleteWarehouse, updateWarehouse } from '@/utils/request'
import vue from '@/main'

const state = {
  warehouseList: []
}

const mutations = {
  RESET (state) {
    state.warehouseList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allWarehouses().then(response => {
        state.warehouseList = response.data
        resolve(state.warehouseList)
      })
    })
  },
  warehouseById ({ commit, state }, id) {
    for (const team of state.warehouseList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, warehouse) {
    return new Promise((resolve) => {
      updateWarehouse(warehouse).then(() => {
        for (const cur of state.warehouseList) {
          if (cur.id === warehouse.id) {
            Object.assign(cur, warehouse)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addWarehouse(team).then((response) => {
        state.warehouseList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, id) {
    return new Promise((resolve) => {
      deleteWarehouse(id).then(() => {
        for (const i in state.warehouseList) {
          if (state.warehouseList[i].id === id) {
            state.warehouseList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
